import { Component, EventEmitter, Input, Output, SimpleChanges, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { AlertInfo } from '../../../../../models/alert-info';
import { SavedDataInfo } from '../../../../../models/form/saved-data-info';
import { AlertNotificationService } from '../../../../../services/alert-notification.service';
import { RegulationsService } from '../../../../../services/api/general-settings/regulations.service';
import { FormService } from '../../../../../services/form.service';
import { ValidatorService } from '../../../../../services/validator.service';

import { CheckboxFieldComponent } from '../../../../../components/form/checkbox-field/checkbox-field.component';
import { NgbAlert } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'regulations-categories',
  imports: [CheckboxFieldComponent, NgbAlert, ReactiveFormsModule],
  templateUrl: './regulations-categories.component.html',
  styleUrl: './regulations-categories.component.scss'
})
export class RegulationsCategoriesComponent implements OnInit {
  @Input() regulationCategory?: any[];
  @Input() readonlyRegulationsCategories: boolean = false;
  @Output() onSavedData = new EventEmitter<SavedDataInfo>();

  form!: FormGroup;

  alertInfo: AlertInfo = { show: false, type: '', message: '' };

  categoriesOptions: { key: string; value: string }[] = [];
  selectedCategoryIds: string[] = [];
  readonly: boolean = false;
  constructor(
    private validatorService: ValidatorService,
    private formService: FormService,
    private alertNotificationService: AlertNotificationService,
    private regulationsService: RegulationsService
  ) {
    this.regulationsService.categories$.subscribe((categories: any) => {            
      this.categoriesOptions = categories?.map((category: any) => ({ 
        key: category.categoryId.toString(),
        value: category.name 
      }));   
      console.log('Categories options:', this.categoriesOptions);
    });
  }

  ngOnInit(): void {
    this.form = new FormGroup({
      category: new FormControl([], [Validators.required]),
    });
  }

  ngOnChanges(changes: SimpleChanges) {   
    if (changes['regulationCategory'] && changes['regulationCategory'].currentValue) { 
      const categories = changes['regulationCategory'].currentValue;
      if (Array.isArray(categories)) {
        this.selectedCategoryIds = categories.map(cat => cat.categoryId.toString());
        
        this.form.patchValue({
          category: this.selectedCategoryIds,
        });
      }
    }
  }

  /**
     * *******************
     * Submit form methods
     * *******************
     */ 
    
  showAlertInfo(type: string, message: string) {
    this.alertInfo = {
      show: true,
      type,
      message
    }
    setTimeout(() => {
      this.alertInfo.show = false;
    }, 3000);
  }
  updateValidationErrors(validationErrors: any) {
    this.formService.resetErrors(this.form);
    this.formService.setValidationErrors(this.form, validationErrors);
  }
  submitFormSuccess(response: any) {
    this.alertNotificationService.success('Operation completed successfully')
    this.showAlertInfo('success', 'Operation completed successfully');

    this.onSavedData.emit({
      success: true,
      response
    });
  }
  submitFormError(error: any) {

    if (error.error.error.description == 'ARGUMENT_VALIDATION_ERROR') {
      this.updateValidationErrors(error.error.error.validationErrors);
    }
    else if (error.error.error.description == 'USER_EMAIL_ALREADY_EXISTS') {
      this.updateValidationErrors([{ field: 'email', defaultMessage: error.error.error.message }]);
      this.showAlertInfo('danger', `Please fix the error: ${error.error.error.message}`);
    }
    else {
      this.showAlertInfo('danger', error.error.error.message);
    }

    this.onSavedData.emit({
      success: false,
      error
    });

  }  submitForm(): void {

   
    Object.keys(this.form.controls).forEach(key => {
      const control = this.form.get(key);
      control?.markAsTouched();
      control?.updateValueAndValidity();
    });

    if (this.form.valid) {
     
      const values = Object.assign(
        this.form.value,
        {
          tenantId: 1,
          categoryIds: this.selectedCategoryIds 
        },
      )

      this.alertInfo.show = false;
      this.formService.resetErrors(this.form);

     
      const serviceMethod = this.regulationCategory && this.regulationCategory.length > 0 ? 
        this.regulationsService.update(this.regulationCategory[0].id, values) : 
        this.regulationsService.create(values);
      serviceMethod.subscribe({
        next: (response: any) => {
          this.submitFormSuccess(response)
        },
        error: (error: any) => {
          this.submitFormError(error)
        }
      })
    }
  }
  /**
   * *******************
   * Submit form methods
   * *******************
   */

  getRegulationJurisdictionsSelect(): FormControl { return this.getFormControl('category'); }

  getFormControl(name: string): FormControl { return this.form.get(name) as FormControl; }
  onCategoriesChange(selectedValues: string[]): void {
    this.selectedCategoryIds = selectedValues;
    this.form.patchValue({
      category: selectedValues
    });
  }
}
